// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'reset';

export const Component = () => (
  <path d='m19.84 7.516.045-2.492c0-.554.277-.83.785-.83.554 0 .83.277.83.83v4.754c0 .507-.277.784-.83.784h-4.8c-.508 0-.785-.277-.785-.784 0-.508.277-.785.785-.785h3.092a8.192 8.192 0 0 0-2.4-2.63c-1.246-.785-2.585-1.2-4.062-1.2-2.031 0-3.785.738-5.216 2.169-1.43 1.43-2.123 3.139-2.123 5.17 0 2.03.693 3.738 2.123 5.169 1.43 1.43 3.185 2.169 5.216 2.169 2.215 0 4.062-.83 5.492-2.446l.093-.093c.23-.139.415-.23.507-.23.6 0 .877.277.877.83 0 .23-.092.416-.23.508-1.8 2.077-4.015 3.092-6.739 3.092-2.446 0-4.57-.877-6.37-2.63C4.378 17.07 3.5 14.946 3.5 12.5c0-2.447.877-4.57 2.63-6.37 1.8-1.753 3.925-2.63 6.37-2.63 1.8 0 3.462.507 4.985 1.523.785.508 1.57 1.339 2.354 2.492v.001Z' />
);

export const viewBox = '0 0 25 25';
